import { createThunkEffect } from "../../utilities/ActionUtility";
import * as UserPasswordEffect from "./UserPasswordEffect";

export const REQUEST_CHANGE_USER_PASSWORD = "UserPasswordEffect.REQUEST_CHANGE_USER_PASSWORD";
export const REQUEST_CHANGE_USER_PASSWORD_FINISHED = "UserPasswordEffect.REQUEST_CHANGE_USER_PASSWORD_FINISHED";

export function changeUserPassword(userId, passwords) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_CHANGE_USER_PASSWORD, UserPasswordEffect.changeUserPassword, userId, passwords);
    };
}
